<template>
  <div class="sticky-add-action">
    <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          color="info"
          fab
          small
          type="button"
          class="white--text"
          :disabled="disabled"
          v-bind="attrs"
          v-on="on"
          @click="$emit('click')"
        >
          <v-icon>mdi-plus</v-icon>
        </v-btn>
      </template>
      <span>{{ tooltip }}</span>
    </v-tooltip>
  </div>
</template>

<script>
export default {
  name: "StickyAddButton",
  props: {
    tooltip: {
      type: String,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped>
.sticky-add-action {
  position: fixed;
  right: 32px;
  bottom: 96px;
  z-index: 3;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  width: auto;
  min-width: 0;
  margin: 0;
  padding: 0;
  pointer-events: none;
}

.sticky-add-action .v-btn {
  pointer-events: auto;
}

@media (max-width: 960px) {
  .sticky-add-action {
    right: 20px;
    bottom: 88px;
  }
}
</style>